/**
 * 计算table的高度，并自动更新
 */
function calcTableSize(){
  setTimeout(function () {
    const ELEMENT_CONTAINER_BODY = '.admin-table .card-body'
    const ELEMENT_CONTAINER_BODY_TABLE = '.admin-table .card-body table'
    const ELEMENT_CONTAINER_FOOTER = '.admin-table .card-footer'
    const ELEMENT_TABS_IFRAME_BODY = '.iframe-mode-disable ' //放在tabs 内容项 iframe中的列表
    if($(ELEMENT_CONTAINER_BODY).length){
      var topDistance = $(ELEMENT_CONTAINER_BODY).offset().top;
      var footerHeight = $(ELEMENT_CONTAINER_FOOTER).length > 0 && $(ELEMENT_CONTAINER_FOOTER).get(0).offsetHeight;
      var cusOffset = 16 + 10;
      var isTabsIframePage = $(ELEMENT_TABS_IFRAME_BODY).length>0?true:false
      if(isTabsIframePage){
        cusOffset = 0
      }
      /*console.log($(ELEMENT_CONTAINER_BODY).height())
      console.log('topDistance:', topDistance);
      console.log('footerHeight:', footerHeight);
      console.log('cusOffset:', cusOffset);*/
      var tableHeight = window.innerHeight - topDistance - footerHeight - cusOffset
      //表格高度大于可显示最大高度时，设置最大高度
      if($(ELEMENT_CONTAINER_BODY_TABLE).height() > tableHeight){
        $(ELEMENT_CONTAINER_BODY).css('height', tableHeight + 'px');
      }
      //console.log('窗口宽：' + window.innerWidth, '窗口高：' + window.innerHeight, '设置高:' + tableHeight)
    }
  }, 100)
}
export default calcTableSize
